import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Link, styled, Switch, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import { REACT_URL_ADD_CARD_TEMPLATE } from "../../actions/EndPoints";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  getCardTemplateList,
  updatePrintStatus,
} from "../../slices/CardTemplate/CardTemplateSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import EditIcon from "../Person/EditIcon";
import DeleteIcon from "../Watchlist/DeleteIcon";
import AddCardTemplate from "./AddCardTemplate";
import DeleteCardTemplate from "./DeleteCardTemplate";
import FilterCardTemplate from "./FilterCardTemplate";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: mode ? "#888B8D" : "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

function CardTemplate() {
  const history = useHistory();
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [clear, setClear] = useState(false);
  const [open, setOpen] = useState(false);
  const [openEditTemplate, setOpenEditTemplate] = useState(false);
  const [openDeleteTemplate, setOpenDeleteTemplate] = useState(false);
  const [cardTemplateId, setCardTemplateId] = useState();
  const [cardTemplateName, setCardTemplateName] = useState();
  const [data, setData] = useState([]);
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [selectedObject, setSelectedObject] = useState({
    id: "",
    name: "",
    description: "",
    companyId: "",
    visitorTypeId: "",
    print: false,
    companyLogo: true,
    companyName: true,
    profile: false,
    firstName: true,
    lastName: true,
    mobile: true,
    email: true,
    visitorType: true,
    checkInTime: true,
    qrCode: true,
    visitorSign: true,
    visitorTypeName: "",
  });

  const [filter, setFilter] = React.useState({
    id: "",
    name: "",
    description: "",
    companyId: "",
    visitorTypeId: "",
    print: false,
    companyLogo: "",
    companyName: "",
    profile: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    visitorType: "",
    checkInTime: "",
    qrCode: "",
    visitorSign: "",
  });

  const defaultFilter = {
    id: "",
    name: "",
    description: "",
    companyId: "",
    visitorTypeId: "",
    print: false,
    companyLogo: "",
    companyName: "",
    profile: false,
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    visitorType: "",
    checkInTime: "",
    qrCode: "",
    visitorSign: "",
  };

  const applyFilter = (filterData) => {
    setClear(true);
    const query = {
      name: filterData.name,
      visitorTypeId: filterData.visitorTypeId,
    };

    setFilter({
      ...filter,
      ...query,
    });
  };

  const resetFilter = () => {
    setClear(false);
    setPage(1);
    setFilter({
      ...defaultFilter,
    });
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    loadData(newPage, size);
    setRowsPerPage(size);
  };

  const handleOpen = () => {
    setOpen(true);
    history.push({
      pathname: REACT_URL_ADD_CARD_TEMPLATE,
    });
  };

  const findVisitorTypeById = (id) => {
    var visitorTypeName = "";
    data.map((visitorData) => {
      if (visitorData.id === id) {
        visitorTypeName = visitorData.name;
      }
    });
    return visitorTypeName;
  };

  const findVisitorTypeByName = (name) => {
    var visitorTypeId = "";
    data.map((visitorData) => {
      if (visitorData.name === name) {
        visitorTypeId = visitorData.id;
      }
    });
    return visitorTypeId;
  };

  useEffect(() => {
    loadData(1, rowsPerPage);
  }, [filter]);

  // useEffect(() => {
  //   loadVisitType()
  // }, [])

  const loadData = (page, rowsPerPage) => {
    const payload = {
      filter: filter,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    dispatch(getCardTemplateList(payload))
      .unwrap()
      .then((data) => {
        console.info(data);
        if ((data.code = "CVAI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.visitors);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      });
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData(page, rowsPerPage);
      setDel(false);
    } else {
      if (del === true) {
        loadData(page - 1, rowsPerPage);
        setDel(false);
      }
    }
  }, [del]);

  const handleEditCardtemplate = (params) => {
    setOpenEditTemplate(!openEditTemplate);
    history.push({
      pathname: REACT_URL_ADD_CARD_TEMPLATE,
      state: { data: params.row },
    });
  };
  const handleDeleteCardtemplate = (params) => {
    setOpenDeleteTemplate(!openDeleteTemplate);
    setCardTemplateId(params.row.id);
    setCardTemplateName(params.row.name);
    setDiaLogBoxBlur(true);
  };

  const handleCheck = (params) => {
    var printValue = !params.row.print;
    const dto = {
      id: params.row.id,
      visitorTypeId: params.row.visitorTypeId,
      name: params.row.name,
      description: params.row.description,
      companyId: params.row.companyId,
      print: printValue,
      companyLogo: params.row.companyLogo,
      companyName: params.row.companyName,
      profile: params.row.profile,
      firstName: params.row.firstName,
      lastName: params.row.lastName,
      mobile: params.row.mobile,
      email: params.row.email,
      visitorType: params.row.visitorType,
      checkInTime: params.row.checkInTime,
      qrCode: params.row.qrCode,
      visitorSign: params.row.visitorSign,
      cardorientation: params.row.cardorientation,
      opType: printValue ? "Enable Print" : "Disable Print",
    };
    dispatch(updatePrintStatus(dto))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0029" && data.data)) {
          loadData(page, rowsPerPage);
        } else {
          Toast(t(data.message), "error");
        }
      });
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },

    {
      field: "cardname",
      headerName: t("COMMON069"),
      flex: 1,
      width: 150,
      valueGetter: (params) => params.row.name,
    },
    {
      field: "visitorTypeId",
      headerName: t("COMMON068"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.visitorTypeData.name,
    },
    {
      field: "description",
      headerName: t("STYPE009"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.description,
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 190,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <Box onClick={() => handleEditCardtemplate(params)}>
          <EditIcon />
        </Box>,
        <Box onClick={() => handleDeleteCardtemplate(params)}>
          <DeleteIcon />
        </Box>,
        <GridActionsCellItem
          icon={
            <Tooltip title={params.row.print ? t("COMMON147") : t("COMMON148")}>
              <Android12Switch
                checked={params.row.print}
                onChange={() => handleCheck(params)}
                mode={darkMode}
              />
            </Tooltip>
          }
          sx={{
            "&:hover": {
              backgroundColor: "transparent", // Removes hover background
              cursor: "default", // Optional: Removes pointer cursor
            },
          }}
        />
      ],
    },
  ]);
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <HeaderToolbar title={t("ADDTEMP1")} />

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{
          gap: "8px",
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "1",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("Card Template")}>
          <Box item className={"addIcon"}
            onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item
            className="refreshIcon"
          >
            <RefreshIcon onClick={() => loadData(page, rowsPerPage)} />
          </Box>
        </Tooltip>

        <Box item>
          <FilterCardTemplate
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => applyFilter(data)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          count={totalRecords}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {open && (
        <AddCardTemplate
          open={open}
          handleClose={() => {
            setOpen(false);
            loadData(page, rowsPerPage);
            setDiaLogBoxBlur(false);
          }}
        />
      )}
      {openEditTemplate && (
        <AddCardTemplate
          selectedObject={selectedObject}
          open={openEditTemplate}
          handleClose={() => {
            setOpenEditTemplate(false);
            loadData(page, rowsPerPage);
            setSelectedObject({
              id: "",
              name: "",
              description: "",
              companyId: "",
              visitorTypeId: "",
              print: "",
              companyLogo: "",
              companyName: "",
              profile: "",
              firstName: "",
              lastName: "",
              mobile: "",
              email: "",
              visitorType: "",
              checkInTime: "",
              qrCode: "",
              visitorSign: "",
            });
          }}
        />
      )}
      {openDeleteTemplate && (
        <DeleteCardTemplate
          open={openDeleteTemplate}
          handleClose={(data) => {
            setOpenDeleteTemplate(data);
            setDiaLogBoxBlur(false);
          }}
          delete={() => setDel(true)}
          DeleteTemplateId={cardTemplateId}
          DeleteTemplateName={cardTemplateName}
        />
      )}
    </>
  );
}

export default CardTemplate;
